export const enData = `
  <div class="paragraph">
    <div class="page-title">Trade-In Frequently Asked Questions (FAQ)</div>
  </div>
  <div class="paragraph">
    <div class="title">Who can join the Trade-In proyect?</div>
    <div class="text-box">
      <div class="text">
        The trade-in Service is available to individuals aged 18 or older who legally reside in any member state of the European Union excluding the Canary Islands, the Balearic Islands, Ceuta and Melilla.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">What should I do before sending my old device?</div>
    <div class="text-box">
      <div class="text">
        Before sending your device:<br>
        • Erase all personal data and remove any PIN, password, or screen lock pattern<br>
        • Perform a full factory reset<br>
        • On iPhone: Disconnect your iCloud account by turning off "Find My iPhone"<br>
        • On Android: Remove your Google account (Settings > Accounts > Google > Remove account)<br>
        • On action camera: Remove any linked account, delete all media files, format the memory card (if applicable), and perform a full factory reset.<br>
        This ensures the device is not linked to your account and protects your personal information.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">How can I send my old device?</div>
    <div class="text-box">
      <div class="text">
        <strong>Packaging:</strong> Use a sturdy, opaque box (not transparent) and add internal protection (bubble wrap or similar) to prevent damage during transport.<br>
        <strong>Packaging materials:</strong> If you don't have proper packaging materials, you can request them at the drop-off point when you bring your parcel.<br>
        <strong>Documentation:</strong> Print, fill out, and sign the Declaration of Honesty and place it inside the package before sealing it.<br>
        <strong>Secure sealing:</strong> Make sure the package is securely closed and affix the free shipping label in a visible spot.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">What types of devices are not accepted?</div>
    <div class="text-box">
      <div class="text">
        We do not accept devices that:<br>
        • are SIM-locked to a carrier;<br>
        • won't power on or charge;<br>
        • cannot connect via Bluetooth or Wi-Fi;<br>
        • have internal component or motherboard failure;<br>
        • cannot take photos or record videos properly;<br>
        • have cracked lenses or severe structural damage;<br>
        • have malfunctioning buttons or stabilization issues;<br>
        • have been exposed to liquid or repaired/disassembled;<br>
        • are still linked to iCloud, Google, or any user account;<br>
        • are counterfeit or replicas;<br>
        • are severely damaged.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Do I need to send accessories (charger, cable)?</div>
    <div class="text-box">
      <div class="text">
        Not mandatory but recommended. Including accessories contributes to sustainability and proper reuse.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Do I also need to send headphones?</div>
    <div class="text-box">
      <div class="text">
        No. For hygiene reasons, headphones will be discarded and not included in the evaluation.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Do I need to send the purchase invoice?</div>
    <div class="text-box">
      <div class="text">
        It is not required for the evaluation or payment. You may keep it for your own records.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">How do you evaluate my old device?</div>
    <div class="text-box">
      <div class="text">
        We use certified diagnostic software and carry out a manual inspection at our assessment center to determine the condition of your device. All evaluation and data handling procedures comply with the General Data Protection Regulation (GDPR – EU 2016/679), ensuring the security and confidentiality of your information.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">What happens if the condition I indicated does not match your evaluation?</div>
    <div class="text-box">
      <div class="text">
        If there are differences between the condition you indicated and our evaluation, we will send you an email with:<br>
        • <strong>An updated offer</strong> based on the actual inspection<br>
        • <strong>The diagnostic report</strong> and the reasons for the difference<br><br>
        You may choose to accept or reject the offer:<br>
        • If you accept, the trade-in will be completed, and you will receive payment in your bank account within 3 business days.<br>
        • If you refuse, the return process will depend on your location:<br>
        &nbsp;&nbsp;• For all customers: a return shipping fee applies, up to a maximum of EUR €22 (VAT included).<br>
        &nbsp;&nbsp;• The fee must be paid within five (5) calendar days after receiving the payment request, using the official prepaid return label provided by Danghuan.<br>
        &nbsp;&nbsp;• Payment details will be provided upon request or included in the payment link email.<br>
        &nbsp;&nbsp;• Once payment is confirmed (if applicable), Danghuan will verify the transaction within five (5) business days and arrange the return shipment to your original address. You will be notified by email once the shipment has been dispatched, including the corresponding tracking information.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">What if I don't respond to the updated offer?</div>
    <div class="text-box">
      <div class="text">
        If no response is received within 5 calendar days from the notification date, the revised quotation will be deemed automatically accepted, without any further notice, reminder, or additional communication from Danghuan.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">What happens to my personal data?</div>
    <div class="text-box">
      <div class="text">
        You must delete all data before sending your old device. If we detect any remaining data, we will pause the process and contact you to remove it. We comply with the GDPR (Regulation EU 2016/679).
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Who pays for shipping costs?</div>
    <div class="text-box">
      <div class="text">
        The initial shipping is always free.<br><br>
        If you reject the updated offer:<br>
        • For all customers: a return shipping fee applies, up to a maximum of EUR €22 (VAT included).<br>
        • The fee must be paid within five (5) calendar days after receiving the payment request, using the official prepaid return label provided by Danghuan.<br>
        • Payment details will be provided upon request or included in the payment link email.<br>
        • Once payment is confirmed (if applicable), Danghuan will verify the transaction within five (5) business days and arrange the return shipment to your original address. You will be notified by email once the shipment has been dispatched, including the corresponding tracking information.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">What happens if my package is lost during shipping?</div>
    <div class="text-box">
      <div class="text">
        If your device is lost during transportation, Danghuan Europe S.L. will assist you with the courier's official claim process.<br><br>
        A shipment is considered lost if it has not been tracked, confirmed, or received by Danghuan within 15 calendar days from handover to the courier.<br><br>
        • You must use the authorized prepaid shipping label provided by Danghuan; using any other method cancels the loss-coverage.<br>
        • Claims for UPS must be filed within 60 days from the label creation date.<br>
        • For CORREOS (Spain) shipments, claims should be filed as soon as possible, ideally within 15 days and no later than 1 year from the shipping date.<br>
        • Danghuan will assist with the courier investigation, which usually takes 30–60 days.<br><br>
        If the loss is confirmed under Danghuan's logistics system and the authorized label was used, the compensation will not exceed the final appraised trade-in value of the device.<br><br>
        Approved payments are transferred directly to the IBAN provided during registration.<br><br>
        <em>Note: Any compensation depends on the courier's policy.</em>
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">When will I receive the payment?</div>
    <div class="text-box">
      <div class="text">
        Once the final offer is accepted, payment will be made via bank transfer within 3 business days. Please ensure your IBAN and Personal ID Number are correct and match the account holder.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Is it mandatory to provide my Personal ID Number?</div>
    <div class="text-box">
      <div class="text">
        Yes, to process the payment, you must provide a valid Personal ID Number, without space or special characters, and it must match the IBAN account holder.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Can I cancel my Trade-In operation?</div>
    <div class="text-box">
      <div class="text">
        Yes, if your old device has not yet been paid for. Please contact us as soon as possible at insta360@danghuan.eu. If your old device has been sent, please contact us in 48 hours, otherwise the recycling process will proceed normally.
      </div>
    </div>
  </div>
`;
